import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/** "Entrar" para visitantes; "Voltar à plataforma" para quem já está conectado. */
export function SessionAwareLink({ className }: { className?: string }) {
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    let active = true;
    supabase.auth.getSession().then(({ data }) => {
      if (active) setSignedIn(!!data.session);
    });
    return () => {
      active = false;
    };
  }, []);
  return signedIn ? (
    <Link to="/inicio" className={className}>
      Voltar à plataforma
    </Link>
  ) : (
    <Link to="/auth" className={className}>
      Entrar
    </Link>
  );
}
